export const Computer = () => (
  <svg width="36" height="32" viewBox="0 0 36 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M32 2H4C2.875 2 2 2.9375 2 4V16H34V4C34 2.9375 33.0625 2 32 2ZM36 16V18V22C36 24.25 34.1875 26 32 26H22.625L23.3125 30H27C27.5 30 28 30.5 28 31C28 31.5625 27.5 32 27 32H22.5H13.5H9C8.4375 32 8 31.5625 8 31C8 30.5 8.4375 30 9 30H12.625L13.3125 26H4C1.75 26 0 24.25 0 22V18V16V4C0 1.8125 1.75 0 4 0H32C34.1875 0 36 1.8125 36 4V16ZM2 18V22C2 23.125 2.875 24 4 24H14.4375H14.5H21.4375C21.5 24 21.5 24 21.5 24H32C33.0625 24 34 23.125 34 22V18H2ZM14.625 30H21.3125L20.625 26H15.3125L14.625 30Z"
      fill="currentColor"
    />
  </svg>
);
